import { getTopic } from "./eventBus"
import { useEffect } from "preact/hooks"
import { useStore } from "@nanostores/preact"

export function useTopicEventSubscribe<T = unknown>(
  name: string,
  callback: (payload: T) => void,
) {
  const store = getTopic<T>(name)
  const payload = useStore(store)

  useEffect(() => {
    if (payload != null) {
      callback(payload)
    }
  }, [callback, payload])
}
